import { useContext, useEffect, useState } from 'react'
import CheckBox from '../../../../components/common/CheckBox'
import Button from '../../../../components/common/Button'
import CloneMappings from '../../../../components/dtcs/TATMappings/CloneMappings'
import { getRequest, putRequest } from '../../../../services/base'
import { createSearchParams, useParams } from 'react-router-dom'
import { NavContext } from '../../../../context/global_context'
import { getLocalStorageData } from '../../../../utils/LocalStorageAccess'

const DtcEdit = () => {
  const [value, dispatch] = useContext(NavContext)

  const [dtcsOptions, setDtcsOptions] = useState([])

  let { dtc_id, vehicle } = useParams()
  const [payload, setPayload] = useState({
    create_dtc_circuits: false,
    clone_with_existing_mapping: false,
    target_dtcs: [],
    active: false,
    destination_only: false,
  })

  const saveDtcs = async () => {
    let res = await putRequest(`/api/dtcs/save_dtcs/${dtc_id}/`, payload)
    dispatch({
      type: 'notification',
      data: {
        notification_type: 'success',
        msg: `DTC's ${value?.dtc_details[0].name} Updated Successfully`,
      },
    })
  }

  useEffect(() => {
    getDtcsList()
  }, [])

  const getDtcsList = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching DTCS Data',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(
      `/api/dtcs/dtcs_options/${dtc_id}/?vehicle_id=${vehicle}`
    )
    setDtcsOptions(res?.data)

    dispatch({
      type: 'header',
      data: {
        header: '',
        sub_header: 'DTC Edit',
        id: '',
        show_back_btn: true,
        dtc_details: res.details,
        vehicle: vehicle,
        back_btn_url: getLocalStorageData('vehicle')?.search
          ? `/vehicles/?${createSearchParams(getLocalStorageData('vehicle'))}`
          : `/vehicles`,
      },
    })
  }

  return (
    <div className="flex w-3/4 px-12">
      <div className="w-1/3">
        <div className="py-2 pt-8">
          <span className="flex pt-4 items-center">
            <CheckBox
              name={'active'}
              value={payload?.active}
              checked={payload?.active}
              onChange={(e) => {
                setPayload({ ...payload, active: e.target.checked })
              }}
            />
            <span className="pl-2 text-white">Active</span>
          </span>
        </div>

        <div className="py-2 ">
          <span className="flex items-center">
            <CheckBox
              name={'destination_only'}
              value={payload?.destination_only}
              checked={payload?.destination_only}
              onChange={(e) => {
                setPayload({ ...payload, destination_only: e.target.checked })
              }}
            />
            <span className="pl-2 text-white">Destination Only</span>
          </span>
        </div>

        <div className="w-1/3">
          <Button
            type="submit"
            className={`cursor-pointer btn my-4 w-full`}
            onClick={(e) => saveDtcs()}
            value={'text'}
            text="Save"
          />
        </div>
      </div>
      <div className="w-2/3">
        <CloneMappings
          payload={payload}
          setPayload={setPayload}
          dtcsOptions={dtcsOptions}
        />
      </div>
    </div>
  )
}

export default DtcEdit
